import { Injectable } from '@angular/core';
import { Notification } from '@core/models/notification/notification';
import { Store } from '@ngrx/store';
import { addNotification, removeAll, removeNotification } from '../store/actions/notifications.actions';
import { AppState } from '../store/reducers/index';

@Injectable()
export class NotificationsService {

  constructor(private store: Store<AppState>) { }

  notify(data: Notification): void {
    this.store.dispatch(addNotification({ payload: data }));
    window.scrollTo(0, 0);
  }

  clear(data: Notification) {
    this.store.dispatch(removeNotification({ payload: data }))
  }

  clearAll(): void {
    this.store.dispatch(removeAll())
  }
}
